import useScreenSize from "hoc/useScreenSize";
import PageContainer from "modules/components/PageContainer";
import Skeleton from "react-loading-skeleton";

function ProductPagePlaceHolder() {
  const [isMobile] = useScreenSize();
  if (isMobile) {
    return (
      <PageContainer
        className="container product-container-v2"
        style={{ display: "flex", flexDirection: "column", width: "100vw" }}
      >

        <Skeleton height={31} count={1} />

        <Skeleton height={54} count={1} />

        <Skeleton height={50} count={1} />

        <Skeleton height={39} count={1} />

        <Skeleton height={32} count={2} />

        <Skeleton height={46} count={1} />

        <Skeleton height={400} count={2} />
      </PageContainer>
    );
  }

  return (
    <PageContainer
      style={{ minHeight: "100%" }}
    >

      <Skeleton height={226} />

      <Skeleton height={800} />

      <Skeleton height={210} />
    </PageContainer>
  );
}

export default ProductPagePlaceHolder;
